<template>
  <div v-if="dataPermission && dataPermission.includes('NSH_REPORT_SELL')">
    <div class="row justify-content-center">
      <div class="col-12">
        <TitlePage :title="title" class="mb-2" />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <div class="pt-3">
                <b>Báo cáo doanh thu</b>
                <p class="mb-0">Theo dõi thu nhập, doanh thu dựa theo:</p>
              </div>
              <div class="card p-3 bg-F2F3F4">
                <b>{{ revenue30days | formatCurrency }}</b>
                <p class="mb-0">Doanh thu 30 ngày vừa qua</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">
                <a
                  class="
                    d-flex
                    justify-content-start
                    align-items-center
                    bd-solid-E5E7E8
                    p-3
                    bd-radius-8px
                    cursor
                  "
                  href="/report-list/revenue-by-time"
                >
                  <div
                    class="
                      w-40px
                      h-40px
                      bg-F2F3F4
                      mr-2
                      bd-radius-4px
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                  >
                    <i class="bx bx-calendar-alt font-size-22"></i>
                  </div>
                  <b class="text-primary">Doanh thu theo<br/>thời gian</b>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  class="
                    d-flex
                    justify-content-start
                    align-items-center
                    bd-solid-E5E7E8
                    p-3
                    bd-radius-8px
                    cursor
                  "
                  href="/report-list/revenue-by-product"
                >
                  <div
                    class="
                      w-40px
                      h-40px
                      bg-F2F3F4
                      mr-2
                      bd-radius-4px
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                  >
                    <i class="bx bx-box font-size-22"></i>
                  </div>
                  <b class="text-primary">Doanh thu theo<br/>sản phẩm</b>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  class="
                    d-flex
                    justify-content-start
                    align-items-center
                    bd-solid-E5E7E8
                    p-3
                    bd-radius-8px
                    cursor
                  "
                  href="/report-list/revenue-by-customer"
                >
                  <div
                    class="
                      w-40px
                      h-40px
                      bg-F2F3F4
                      mr-2
                      bd-radius-4px
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                  >
                    <i class="bx bx-heart font-size-22"></i>
                  </div>
                  <b class="text-primary">Doanh thu theo<br/>khách hàng</b>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  class="
                    d-flex
                    justify-content-start
                    align-items-center
                    bd-solid-E5E7E8
                    p-3
                    bd-radius-8px
                    cursor
                  "
                  href="/report-list/revenue-by-payment"
                >
                  <div
                    class="
                      w-40px
                      h-40px
                      bg-F2F3F4
                      mr-2
                      bd-radius-4px
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                  >
                    <i class="bx bx-money font-size-22"></i>
                  </div>
                  <b class="text-primary">Doanh thu theo<br/>phương thức TT</b>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-if="role && role == 'owner'">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <div class="pt-3">
                <b>Báo cáo lợi nhuận</b>
                <p class="mb-0">Theo dõi lợi nhuận bán hàng:</p>
              </div>
              <div class="card p-3 bg-F2F3F4">
                <b>{{ profit30days | formatCurrency }}</b>
                <p class="mb-0">Lợi nhuận 30 ngày vừa qua</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">
                <a
                  class="
                    d-flex
                    justify-content-start
                    align-items-center
                    bd-solid-E5E7E8
                    p-3
                    bd-radius-8px
                    cursor
                  "
                  href="/report-list/profit-by-time"
                >
                  <div
                    class="
                      w-40px
                      h-40px
                      bg-F2F3F4
                      mr-2
                      bd-radius-4px
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                  >
                    <i class="bx bx-calendar-alt font-size-22"></i>
                  </div>
                  <b class="text-primary">Lợi nhuận theo<br/>thời gian</b>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  class="
                    d-flex
                    justify-content-start
                    align-items-center
                    bd-solid-E5E7E8
                    p-3
                    bd-radius-8px
                    cursor
                  "
                  href="/report-list/profit-by-product"
                >
                  <div
                    class="
                      w-40px
                      h-40px
                      bg-F2F3F4
                      mr-2
                      bd-radius-4px
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                  >
                    <i class="bx bx-box font-size-22"></i>
                  </div>
                  <b class="text-primary">Lợi nhuận theo<br/>sản phẩm</b>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ReportService } from "@/services/nextshop/report.service";
import TitlePage from "@/components/title-page";
import VueCookies from "vue-cookies";
import moment from "moment";

export default {
  components: {
    TitlePage,
  },
  page: {
    title: "BÁO CÁO BÁN HÀNG",
  },
  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      role: JSON.parse(localStorage.getItem("auth.currentUser")).role,
      title: "BÁO CÁO BÁN HÀNG",
      LID: VueCookies.get("LID"),
      dateRange: {
        startDate: moment(moment().subtract(30, "days")._d).format("YYYYMMDD"),
        endDate: moment(moment().subtract(1, "day")._d).format("YYYYMMDD")
      },
      revenue30days: 0,
      profit30days: 0,
    };
  },
  created() {
    this.totalReportV3();
  },

  methods: {
    async totalReportV3() {
      this.loading = true;
      try {
        const params = {
          "dimensionTime": "DAY",
          "locationId": this.LID,
          "orderStatus": "SUCCESS",
          "fromDate": this.dateRange.startDate,
          "toDate": this.dateRange.endDate,
          "isRealtime": true
        }
        const response = await ReportService.totalOrderReportV3(params)
        if(response.success){
          this.revenue30days = this.divisionThousand(response.data[0].netRevenue)
          this.profit30days = this.divisionThousand(response.data[0].profit)
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    }
  }
};
</script>
<style>
</style>